import React from "react";
import { Card } from "rebass";

import { CopyContentControl } from "./CopyContentControl";
import { EditControl } from "./EditControl";
import { FontSizeControl } from "./FontSizeControl";
import { OriginControl } from "./OriginControl";

export const RecordControl: React.FC = () => (
  <Card
    borderRadius="inherit"
    m="-15px -21px"
    css="overflow: hidden;"
  >
    <FontSizeControl />

    <OriginControl />

    <EditControl />

    <CopyContentControl />
  </Card>
);
